export * from './negocios-kanban-filters.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-kanban/negocios-kanban-filters/index.ts